export default {
    black: '#000000',
    white: '#ffffff',
    glanceRed: '#fd104d',
    glanceRed2: '#ff0049',
    torchRed: '#fc024d',
    nobel: '#b4b3b3',
    heather: '#bcc3d3',
    mineShaft: '#3f3f3f',
    doveGray: '#6a6a6a',
    silver: '#c1c1c1',
    redRibbon: '#f91151',
    wildSand: '#f4f4f4',
    concrete: '#f3f3f3',
    emperor: '#555555',
    glanceBlack: '#1b2138',
    codGray: '#171717',
    pickledBluewood: '#323955',
    bubbleRed: '#c80000',
    bubbleBlue: '#3364ef',
    heartGradient: 'linear-gradient(180deg, #ff619a 0%, #ff005c 100%)',
    redGradient: 'linear-gradient(180deg, #E9AC9F 0%, #FD0000 100%)',
    yellowGradient: 'linear-gradient(180deg, #FEE78A 0%, #FE9118 100%)',
    blueGradient: 'linear-gradient(180deg, #AACAFF 0%, #3762F9 100%)',
};
//# sourceMappingURL=colors.js.map